import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

export function useLatestRecordId() {
  const localLatestRecordId = useSelector(
    state => state.localStore.latestRecordId
  )
  const remoteLatestRecordId = useSelector(
    state => state.recordHistory.latestRecordId
  )
  const [latestRecordId, setLatestRecordId] = useState(null)

  useEffect(() => {
    if (remoteLatestRecordId == null) {
      setLatestRecordId(localLatestRecordId)
    } else {
      setLatestRecordId(remoteLatestRecordId)
    }
  }, [localLatestRecordId, remoteLatestRecordId])

  return latestRecordId
}
